import { useEffect, useSyncExternalStore } from 'react';
import { magasinAppel } from '../features/brigitte/appel-en-cours.js';
import { App } from './App.js';
import { proprietesApp, type Controleur } from './controleur.js';
import { brancherEvenements } from './navigateur.js';
import { COULEURS, POLICE_SYSTEME } from './styles.js';

/** Racine React : lit l’état du contrôleur, branche les événements du navigateur et démarre la session. */
export function Racine({ controleur, donneesExemple = false }: { controleur: Controleur; donneesExemple?: boolean }) {
  const etat = useSyncExternalStore(controleur.subscribe, controleur.getEtat, controleur.getEtat);
  useEffect(() => {
    const debrancher = brancherEvenements(window, controleur);
    void controleur.demarrer();
    return debrancher;
  }, [controleur]);
  // Un appel ouvert (M02) retient les pop-ups BETA (UX-17, ARB-APPEL-38) : la coquille suit le signal de l'écran d'appel.
  useEffect(() => {
    const suivre = () => controleur.definirAppel(magasinAppel.enCours());
    suivre();
    return magasinAppel.abonner(suivre);
  }, [controleur]);

  if (!etat.sessionChargee) {
    return (
      <p role="status" style={{ padding: 24, fontFamily: POLICE_SYSTEME, fontSize: 18, color: COULEURS.marine }}>
        Chargement de votre espace…
      </p>
    );
  }
  return <App {...proprietesApp(controleur, { donneesExemple })} />;
}
